// extracted by mini-css-extract-plugin
export default {"root":"simpleReportText_root__aD2si","textWrapper":"simpleReportText_textWrapper__1DHUU","textInner":"simpleReportText_textInner__1MwBm","item":"simpleReportText_item__4I1fE"};